import React from 'react';
import PropTypes from 'prop-types';
import {Message} from '../';
import Spacer from '../common/spacer/Spacer';

const UserCabinedMode = ({configState}) => {
    return (
        <Spacer className="container min-height" top={40}>
            <Message as="p" code="epic.esport.content_gate.title" />
            <Message as="p" code="epic.esport.cabined_mode.info" args={[configState.accountPortal]} />
        </Spacer>
    );
};

UserCabinedMode.propTypes = {
    configState: PropTypes.object
};

export default UserCabinedMode;
